import { ContractTypeOption } from '@immosky/types';

export const availableContractTypeOptions: ContractTypeOption[] = [
  {
    text: 'filters.contractType.buy',
    value: 'buy',
  },
  {
    text: 'filters.contractType.rent',
    value: 'rent',
  },
];
